import { styled } from "@mui/material";

const FormLabel = styled("label")({
    fontSize: "1rem",
    color: "#333",
});

const CaltexFormLabel = (props) => {
    return <FormLabel>{props.children}</FormLabel>;
};

export default CaltexFormLabel;
